// ** Auth Endpoints
const apiConfig = {
  docAssemble: {
    NewUser: "/docassemble_proxy/create_user",
    LoginURL: "/docassemble_proxy/loginurl",
    Logout: "/web-da/docassemble/user/sign-out",
    Session: "/docassemble_proxy/new_session",
    Answer: "/docassemble_proxy/answers",
  },
  elit: {
    ICA: "/elit_proxy/caveat_ica_search",
  },
  probate: {
    Landing: "/landing/home",
    Logout: "/landing/logout",
    DownloadPBOS: "/landing/download_pbos",
    CallbackAfterLogin: "/landing/callback_afterlogin",
    CheckAutoLoginSession: "/landing/check_autologin_session",
    GetDocuments: "/documentchecklist/get_documents",
    DownloadDocument: "/documentchecklist/download_document",
    UpdateDocumentsChecklist: "/documentchecklist/update_documents_checklist",
    CheckIsResubmittedPhase: "/documentchecklist/check_isresubmitted_phase",
    CaveatICA: "/probateform/caveat_ica_result",
    ICACorrectness: "/caveat_ica/save_correctness",
    CheckApplicantAddress: "/caveat_ica/check_applicant_address",
    GetGeneratedSOA: "/scheduleofassets/generated_pdf",
    GetSoaDoc: "/scheduleofassets/get_soa_doc_list",
    CheckSOA: "/scheduleofassets/check_soa",
    SetLateSoa: "/scheduleofassets/set_late_soa",
    GetLatestSoa: "/scheduleofassets/get_latest_soa",
    SaveRoute: "/common/save_route",
    GetCountries: "/common/countries",
    GetCaseCode: "/common/get_casecode",
    GetCaseStatus: "/common/get_casestatus",
    CalculateFees: "payment/calculate_fees",
    ProceedToPay: "payment/proceed_to_pay",
    ProceedToSettle: "payment/proceed_to_settle",
    GetPaymentAndFeeDetails: "payment/get_payment_fee_details",
    ProceedToRefund: "refund/proceed_to_refund",
    CheckMainSubmissionDone: "payment/check_mainsubmission_done",
    PdfValidate: "common/pdf_validation",
    PdfValidate2: "common/pdf_validation2",
    GetRefundDetails: "refund/get_refund_details",
    GetWithdrawalDetails: "refund/get_withdrawal_details",
    GetPaymentHistory: "payment/get_payment_trans",
    WithdrawProbateCase: "refund/withdraw_probate_case",
    SubmitAdminOathAffidavitDocuments:
      "/adminoathaffidavit/submit_admin_oath_affidavit",
    SubmitSupplementaryAffidavitDocuments:
      "/adminoathaffidavit/submit_supplementary_affidavit",
    GetAdminOathAffidavitDocumentList: "/adminoathaffidavit/document_list",
    GetAdminOathAffidavitInformation: "/adminoathaffidavit/get_info",
    GetAdminOathAffidavitPdf: "/adminoathaffidavit/generated_pdf",
    RequestAdminOathAffidavitTimeExtension:
      "/adminoathaffidavit/request_time_extension",
    Notification_Documents: "/common/document_info",
    GetHearingDetails: "/hearing/get_hearing_details",
    DownloadOIT: "/hearing/download_oit",
    GrantStatus: "extractionofgrant/grant_status",
    DownloadGrant: "extractionofgrant/download_grant",
    GetProbateStatus: "/common/menu_status",
    ShouldSoaDisabled: "/common/should_SOA_Disabled",
    ErrorReporter: "/common/browser_log",
  },
  //refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: "/identity/logout",

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};

export default apiConfig;
